var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c("div", { staticClass: "top" }, [_vm._v("投诉记录")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.list, function(item, index) {
          return _c("div", { key: index, staticClass: "item" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "text-1" }, [
                _vm._v(_vm._s(item.create_time))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-2" }, [
                _vm._v("联系人：" + _vm._s(item.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-2" }, [
                _vm._v("问题：" + _vm._s(item.desc))
              ])
            ]),
            _vm._v(" "),
            item.result
              ? _c(
                  "div",
                  {
                    staticClass: "right",
                    on: {
                      click: function($event) {
                        ;(_vm.one = item), (_vm.modal = true)
                      }
                    }
                  },
                  [_vm._v("\n        已处理\n      ")]
                )
              : _vm._e()
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            showConfirmButton: false,
            width: "6.5rem",
            closeOnClickOverlay: true
          },
          model: {
            value: _vm.modal,
            callback: function($$v) {
              _vm.modal = $$v
            },
            expression: "modal"
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "text-1" }, [
              _c("span", [_vm._v("问题：" + _vm._s(_vm.one.desc))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-2" },
              [
                _c("span", [_vm._v("附件：")]),
                _vm._v(" "),
                _vm._l(_vm.one.files, function(item, index) {
                  return _c("img", {
                    key: index,
                    attrs: { src: item },
                    on: {
                      click: function($event) {
                        return _vm.showImg(item)
                      }
                    }
                  })
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-1" }, [
              _c("span", [_vm._v("处理结果：" + _vm._s(_vm.one.result))])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("../assets/images/tousujilu_03.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-560b4670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560b4670","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tousujilu.vue
// module id = null
// module chunks = 